import React from "react";
import { withStyles, Dialog, DialogContent, DialogTitle, withTheme } from '@material-ui/core';
import Cancel from "@material-ui/icons/CancelOutlined";
import ReactHtmlParser from 'react-html-parser';
import AnimationRenderer from "../animations/animationRenderer";
import * as RMAXMaintenanceAnimation from "./../animations/json/RMAXMaintenanceAnimation.json"
import { compose } from "recompose";

const styles = theme => ({
  dialogRoot:{
    cursor:"pointer",
    userSelect:"none"
  },
  dialogContainer: {
    borderRadius: "2px",
    background: theme.ModalBGColor,
    overflow: "visible",
    position: "relative"
  },
  dialogTitle: {
    padding: 0,
    position: "relative"
  },
  dialogContent: {
    fontSize: "14px",
    fontWeight: "bold",
    lineHeight: "19px",
    padding: "30px 50px",
    textAlign: "justify",
    color: theme.gridTextColor,
    backgroundColor: theme.maintenanceBGColor,
    '& b':{
      color: theme.HeaderSelectedText
    }
  },
  supportLink: {
    color: theme.HeaderSelectedText,
    fontSize: "16px",
    textAlign: "center",
    textDecoration: "underline",
    lineHeight: "22px",
    paddingTop: "20px",
    cursor: "pointer"
  },
  time: {
    color: theme.HeaderSelectedText
  },
  closeIcon:{
    fontSize:24,
    position:"absolute",
    right:-12,
    top:-12,
    backgroundColor: theme.ModalBGColor,
    color: theme.HeaderSelectedText,
    borderRadius:"50%",
    zIndex: 1,
  },
  messageContent:{
    overflowY:"auto",
    maxHeight:250,
    padding:"0px 10px"
  },
  imageWrapper: {
    width: "600px",
    height: "400px",
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "cover"
  },
  animationContainer: {
    transform: "translate(1%, -128%)",
    display: 'flex',
    gap: '92px'
  },
  maintenanceLabel: {
    fontSize: 30,
    fontWeight: 700,
    lineHeight: '34px',
    color: theme.palette.primary.main,
    alignContent: 'center'
  },
});

const RMAXMaintenance = (props)  => {
  function contactSupport(){
    const iframe = document.getElementById("launcher-frame");
    if(iframe){
      const innerDoc = iframe.contentDocument || iframe.contentWindow.document;
      const freshdeskClickable = innerDoc ? innerDoc.querySelector('[data-testid="launcher-wrapper"]') : null;
      freshdeskClickable && freshdeskClickable.click && freshdeskClickable.click();
    }
  };

  const convertStringToHtml = (text) => {
    if (!text) return null;    
    // Convert line breaks to <br> tags
    const htmlString = text.replace(/(\r\n|\n|\r)/g, "<br />")         // replace new line with "<br />" to indicate single paragraph
                                  .replace(/(<br \/>){2,}/g, "\n")            // min 2 <br /> indicates new paragraph
                                  .split("\n")                                
                                  .filter(Boolean)                             // get array of paragraph string  
                                  .map(paragraphContent => `<p>${paragraphContent}</p>`)           // wrap each paragraph content with <p> tag
                                  .join("");
    
    // Parse the HTML string using ReactHtmlParser
    return ReactHtmlParser(htmlString);
  };

   const { classes, isClosable, message } = props;
   const htmlContent = convertStringToHtml(message);
   return (
     <Dialog
       open
       classes={{ paper: classes.dialogContainer, root: classes.dialogRoot }}
       className={`dialog ${props.theme.themeName || "modernLight"}`}>
       <DialogTitle disableTypography classes={{ root: classes.dialogTitle }}>
         {isClosable ? (
           <Cancel classes={{ root: classes.closeIcon }} onClick={props.onClose} />
         ) : null}
         <div className={classes.imageWrapper}>
           <img
             src={`../../../../images/RMaxErrorBG-${
               'modernDark' === props.theme.themeName ? 'dark' : 'light'
             }.jpg`}
             alt="RMAX Maintenance"
             className={classes.image}
           />
           <div className={classes.animationContainer}>
             <AnimationRenderer dimension={250} animationJSON={RMAXMaintenanceAnimation} />
             <div className={classes.maintenanceLabel}>
               Scheduled <br />
               Maintenance
             </div>
           </div>
         </div>
       </DialogTitle>
       <DialogContent className={classes.dialogContent}>
         <div className={`${classes.messageContent} customScroll`}>{htmlContent}</div>
         <div className={classes.supportLink} onClick={contactSupport}>
           Contact Support
         </div>
       </DialogContent>
     </Dialog>
   );
}

export default compose(withStyles(styles), withTheme())(RMAXMaintenance);

